import {
  MassChannel,
  MassJobStatus,
} from '#/shared/api/generated/communication/models'
import type { MassJobSummary } from '#/shared/api/generated/communication/models'
import { isJobTerminal } from '#/shared/lib/mass-jobs'

import { MASS_CHANNEL, MASS_STATUS } from '../model/types'
import type { ProgressState } from '../model/types'

export const SEND_MASS_CHANNELS = [
  MASS_CHANNEL.sms,
  MASS_CHANNEL.email,
] as const

export type SendMassChannel = (typeof SEND_MASS_CHANNELS)[number]

const JOB_CHANNEL_OF: Record<SendMassChannel, MassChannel> = {
  [MASS_CHANNEL.sms]: MassChannel.sms,
  [MASS_CHANNEL.email]: MassChannel.email,
}

function startedAtMs(job: MassJobSummary): number {
  return Date.parse(job.started_at ?? job.created_at)
}

export function massJobToProgress(
  job: MassJobSummary,
  status: ProgressState['status'] = MASS_STATUS.sending,
): ProgressState {
  return {
    status,
    done: job.done,
    total: job.total,
    queue: Math.max(0, job.total - job.done),
    startedAt: startedAtMs(job),
    paused: job.status === MassJobStatus.paused,
    jobId: job.id,
  }
}

function lastActive(
  jobs: MassJobSummary[],
  channel: MassChannel,
): MassJobSummary | undefined {
  const active = jobs.filter(
    (job) => job.channel === channel && !isJobTerminal(job),
  )
  return active[active.length - 1]
}

export function activeJobForChannel(
  channel: SendMassChannel,
  jobs: MassJobSummary[],
): MassJobSummary | undefined {
  return lastActive(jobs, JOB_CHANNEL_OF[channel])
}

/** The caller's running power-dial session, if any — `channel: "call"` rides the
 *  same unified jobs list as the sends. */
export function activeCallJob(
  jobs: MassJobSummary[],
): MassJobSummary | undefined {
  return lastActive(jobs, MassChannel.call)
}
